import React, { createRef } from 'react';
import { MapTool } from "./tools";
import Overlay from "ol/Overlay";
import './index.scss';
import "./Map.scss";
import infoService from './services/infoService';
import { Toast } from 'primereact/toast';
import { InfoPopup, ModifyOverlay } from './components';
import * as olCoordinate from 'ol/coordinate';
import 'primereact/resources/themes/lara-light-cyan/theme.css';
import 'primeflex/primeflex.css';
import 'primeicons/primeicons.css';
import 'primereact/resources/primereact.css';
import proj4 from 'proj4';
import { InputNumber } from 'primereact/inputnumber';
import { Button } from 'primereact/button';
import { ButtonGroup } from 'primereact/buttongroup';
import DragAndDrop from 'ol/interaction/DragAndDrop.js';
import GPX from 'ol/format/GPX.js';
import GeoJSON from 'ol/format/GeoJSON.js';
import IGC from 'ol/format/IGC.js';
import KML from 'ol/format/KML.js';
import TopoJSON from 'ol/format/TopoJSON.js';

export class Map extends React.Component {

    id = this.props.id ?? "map";

    mapTool = new MapTool();
    mapRef = { current: this };

    constructor(props) {
        super(props);

        this.state = {
            visibleInfoPanel: false,
            value: this.props.view.zoom,
            infoData: [],
            rotateControls: this.props.rotateControls
        }

        this.toast = createRef(null);
    }

    render = () => {

        return <>
            <Toast ref={this.toast} />
            <div id={this.id} />
            <div className='bs-zoom-control' style={this.state.rotateControls ? { display: "flex" } : { display: "unset" }}>

                <InputNumber min="1" max="26" value={Math.floor(this.state.value)} onValueChange={(e) => this.setState({ value: e.value })} showButtons buttonLayout="vertical"
                    decrementButtonClassName="p-button-secondary" incrementButtonClassName="p-button-secondary" incrementButtonIcon="pi pi-plus" decrementButtonIcon="pi pi-minus" />
            </div>

            {
                this.state.rotateControls &&
                <div className="card flex justify-content-center" style={{ position: "absolute", bottom: "1rem", right: "4rem", zIndex: 2 }}>

                    <Button className='p-button-custom mr-1' size="small" icon="pi pi-replay" text raised aria-label="SYT Döndür" onClick={() => this.rotateMap(-10)} />
                    <Button className='p-button-custom' size="small" icon="pi pi-refresh" text raised aria-label="SY Döndür" onClick={() => this.rotateMap(10)} />

                </div>
            }

            <div>
                <ModifyOverlay
                    dynamicRuleApiUrl={this.props.dynamicRuleApiUrl}
                    showModifyButtons={this.props.showModifyButtons}
                    wfsOperationResult={this.props.wfsOperationResult}
                    wfsOperationResultFunc={this.props.wfsOperationResultFunc}
                    wfsModifyMeasure={this.props.wfsModifyMeasure}
                    onSuccess={
                        (data) => {
                            this.props.wfsReturnData(data)
                        }
                    }
                    onDelete={
                        (data) => {
                            this.props.wfsReturnDeletingData(data)
                        }
                    }
                    toastRef={this.toast}
                    map={this.mapRef}
                />
            </div>

            {
                this.state.visibleInfoPanel &&
                <InfoPopup
                    map={this.mapRef}
                    infoColor={this.props.infoColor}
                    dynamicFormTokenKey={this.props.mapTokenKey}
                    visible={this.state.visibleInfoPanel}
                    infoData={this.state.infoData}
                    visibleFunc={() => this.closeInfoWindow()}
                    isGetInfoRowData={this.props.isGetInfoRowData}
                    getInfoRowDataFunc={this.props.getInfoRowDataFunc}
                    dynamicData={this.props.dynamicData}
                    toastRef={this.toast}
                    checkIdentifierColumn={this.props.checkIdentifierColumn}
                />
            }
        </>;
    }

    rotateMap = (degrees) => {
        //console.log(degrees)
        let view = this.mapTool.getMap().getView();
        const currentRotation = view.getRotation();
        const radians = degrees * (Math.PI / 180);
        view.setRotation(currentRotation + radians);
        //this.setState({ rotationLocalState: currentRotation + radians });
    };

    componentDidUpdate = (prevProps, prevState) => {

        if (prevState.value !== this.state.value) {

            this.mapTool.setZoomLevel({ zoomLevel: this.state.value });
        }
        if (this.props.rotateControls && this.props.rotateControls === true) {
            let elements = document.getElementsByClassName('ol-rotate');
            Array.from(elements).forEach((elem) => {
                elem.style.display = "unset";
            });

        }
        else if (this.props.rotateControls && this.props.rotateControls === false) {
            let elements = document.getElementsByClassName('ol-rotate');
            Array.from(elements).forEach((elem) => {
                elem.style.display = "none";
            });
        }
        else {
            let elements = document.getElementsByClassName('ol-rotate');
            Array.from(elements).forEach((elem) => {
                elem.style.display = "none";
            });
        }
    }

    componentDidMount = () => {

        let mainDiv = document.createElement("div");
        mainDiv.className = "ol-popup";
        mainDiv.id = "map-popup";
        document.body.appendChild(mainDiv);

        let headerDiv = document.createElement("div");
        headerDiv.className = "headerpopup";

        let aTag = document.createElement("a");
        aTag.id = "popup-closer";
        aTag.className = "ol-popup-closer";
        aTag.addEventListener("click", () => {
            that.setState({ selection: null });
        });

        headerDiv.appendChild(aTag);

        let contentDiv = document.createElement("div");
        contentDiv.id = "popup-content";

        let foorterDiv = document.createElement("div");
        foorterDiv.id = "popup-footer";

        mainDiv.appendChild(headerDiv);
        mainDiv.appendChild(contentDiv);
        mainDiv.appendChild(foorterDiv);

        window.mapTokenKey = this.props.mapTokenKey;

        if (this.props.bms) {

            this.mapTool.setBmsKey(this.props.bms)
        }

        if (this.props.bingKey) {

            this.mapTool.setBingKey(this.props.bingKey)
        }

        this.mapTool.setGoogleKey(this.props.googleKey);

        this.mapTool.setYandexKey(this.props.yandexKey);

        this.mapTool.wktProjection = this.props.wktProjection ? this.props.wktProjection : "EPSG:4326";

        this.mapTool.createMap(
            {
                id: this.id,
                view: this.props.view,
                hasMouseControl: this.props.hasMouseControl,
                hasContextMenu: this.props.hasContextMenu,
                contextMenuItems: this.props.contextMenuItems,
                extraMenuItems: this.props.extraMenuItems,
                extraMenuNavigationItems: this.props.extraMenuNavigationItems
            });

        this.mapTool.addBaseMap(this.props.baseMap ?? "NONE");

        this.mapTool.createPopupOverlay("popupOverlay", "map-popup");

        this.addDefaultLayers();

        this.addDefaultInteractions();

        this.mapTool.getMap().on('moveend', () => {
            this.setState({
                value: this.mapTool.getMap().getView().getZoom()
            });
            if (document.querySelector(".bs-zoom-control input")) {
                document.querySelector(".bs-zoom-control input").setAttribute("disabled", false);
            }
            this.mapTool.updatePermalink();
        });

        this.mapTool.setInfoWindowFunc(this.openInfoWindowWithoutInteraction);

        const element = document.getElementById("wfs_modify_action_buttons");

        if (element) {
            const modify_overlay = this.mapTool.createOverlay("modify-feature-overlay", element, 'bottom-center', [0, -10]);

            this.mapTool.getMap().addOverlay(modify_overlay);
        }

        const element2 = document.getElementById("modify-feature-measure");

        if (element2) {
            const modify_overlay = this.mapTool.createOverlay("modify-feature-measure", element2, 'bottom-center', [0, -10]);

            this.mapTool.getMap().addOverlay(modify_overlay);
        }

        let that = this;

        this.mapTool.getMap().getLayers().on('propertychange', (e) => {
            let layers = this.mapTool.getMapVectorLayers();
            if (layers.length > 0) {
                const selectEditInteraction = this.mapTool.getInteraction("select_edit_interaction");
                const selectHoverInteraction = this.mapTool.getInteraction("select_hover_interaction");
                if (selectEditInteraction && selectHoverInteraction) {
                    for (let index = 0; index < layers.length; index++) {
                        const layer = layers[index];
                        selectEditInteraction.addLayers(layer);
                        selectHoverInteraction.addLayers(layer);
                    }

                }
            }
        });

        this.mapTool.getMap().getInteractions().on('propertychange', (e) => {
            that.mapTool.setDoubleClickZoomActive(false);
        });

        this.mapTool.getMap().on('pointermove', (event) => {
            const snappedFeature = that.mapTool.findSnappedFeature(event.coordinate);

            if (!snappedFeature) {
                that.mapTool.getMap().getTargetElement().style.cursor = '';
            }
        });

        document.body.addEventListener('keydown', function (e) {
            if (e.key == "Escape") {
                that.mapTool.disableAllInteractions();
                that.toast.current.show({ severity: 'info', summary: 'Çizim İşlemleri', detail: 'Aktif tüm çizimler sonlandırıldı. ', life: 3000 });
            }
        });
    }

    closeInfoWindow = () => {

        this.setState({
            visibleInfoPanel: false,
            infoData: []
        });
    }

    getWfsLayerIdentifierColumn = async (layerId, properties, data) => {
        try {
            delete properties.geometry;

            const model = {
                layerId: layerId,
                properties: JSON.stringify(properties)
            }

            let response = await infoService.getIdentifierInfo(this.props.mapApiUrl, model).catch(err => {
                data = [];
            });

            if (response && response.success) {
                data = response.data || [];
            } else {
                data = [];
            }
        } catch (error) {
            data = [];
        }
    }


    openInfoWindow = async (event) => {
        event.target.setActive(false);

        let that = this;

        that.mapTool.clearLayersByName(["info-layer"]);

        let wfsLayers = event.target.getMap().getLayers().getArray().filter(x => x.getProperties().name.includes("base-wfs-layer-") && x.getVisible() === true);

        let data = [];

        if (wfsLayers && wfsLayers.length > 0) {
            for (let i = 0; i < wfsLayers.length; i++) {

                if (that.mapTool.getActiveLayer() && that.mapTool.getActiveLayer().length > 0) {
                    const wfsLayer = wfsLayers[i];

                    const layerId = wfsLayer.get("name").split("base-wfs-layer-")[1];

                    let layer = that.mapTool.getActiveLayer().find(x => x.key === parseInt(layerId));

                    const source = wfsLayer.getSource();

                    if (source) {
                        await source.forEachFeatureIntersectingExtent(event.feature.getGeometry().getExtent(), async (feature) => {
                            const properties = feature.getProperties();

                            if (that.state.infoData.length > 0) {

                                let newData = that.state.infoData.filter(x => x.properties.id !== properties.id);

                                if (newData.length === 0) {
                                    const featureIds = feature.getId().toString().split(".");

                                    const id = featureIds.pop();

                                    const name = featureIds[0];

                                    const geoJSON = MapTool.convertFeatureToGeoJson(newFeature, that.props.mapProjection);

                                    let identifierColumn = [];

                                    delete properties.geometry;

                                    if (that.props.checkIdentifierColumn) {
                                        const model = {
                                            layerId: layerId,
                                            properties: JSON.stringify(properties)
                                        }

                                        let response = await infoService.getIdentifierInfo(this.props.mapApiUrl, model).catch(err => {
                                            data = [];
                                        });

                                        if (response && response.success) {
                                            identifierColumn = response.data || [];
                                        }
                                    }

                                    data.push({
                                        id: id,
                                        idColumn: null,
                                        isFormExist: false,
                                        name: name,
                                        properties: properties,
                                        title: layer?.title,
                                        identifierColumns: identifierColumn,
                                        geoJSON: geoJSON
                                    });
                                }
                            }
                            else {
                                let newData = data.filter(x => x.properties.id !== properties.id);

                                if (newData.length === 0) {
                                    const featureIds = feature.getId().toString().split(".");

                                    const id = featureIds.pop();

                                    const name = featureIds[0];

                                    const geoJSON = MapTool.convertFeatureToGeoJson(feature, that.props.mapProjection);

                                    let identifierColumn = [];

                                    delete properties.geometry;

                                    if (that.props.checkIdentifierColumn) {
                                        const model = {
                                            layerId: layerId,
                                            properties: JSON.stringify(properties)
                                        }

                                        let response = await infoService.getIdentifierInfo(this.props.mapApiUrl, model).catch(err => {
                                            identifierColumn = [];
                                        });

                                        if (response && response.success) {
                                            identifierColumn = response.data || [];
                                        }
                                    }

                                    data.push({
                                        id: id,
                                        idColumn: null,
                                        isFormExist: false,
                                        name: name,
                                        properties: properties,
                                        title: layer?.title,
                                        identifierColumns: identifierColumn,
                                        geoJSON: geoJSON
                                    });
                                }
                            }
                        });
                    }
                }
            }

            if (data.length > 0) {
                that.setState({ infoData: [...that.state.infoData, ...data] }, () => {
                    that.setState({ visibleInfoPanel: true })
                });
            }
        }

        let wmsLayers = event.target.getMap().getLayers().getArray().filter(x => x.getProperties().name.includes("wms-layer-") && x.getVisible() === true);

        for (let i = 0; i < wmsLayers.length; i++) {

            let source = that.mapTool.getLayerSource(wmsLayers[i].get("name"));

            const coordinates = event.feature.getGeometry().getCoordinates();

            if (source.getParams().layers.length > 0) {

                let visibleLevels = source.getParams().visibleLevel;

                let controlLayersZoom = visibleLevels.filter(x => x.minVisibleLevel <= that.mapTool.getZoom() && x.maxVisibleLevel >= that.mapTool.getZoom()).map(x => x.key);

                if (controlLayersZoom.length === 0) {
                    continue;
                }
                else {
                    source.getParams().layers = controlLayersZoom;
                }

                infoService.getFeatureInfo(that.mapTool, coordinates, wmsLayers[i].get("name"), event.feature, that.props.checkIdentifierColumn).then((response) => {

                    if (!response.success) {

                        that.toast.current.show({ severity: 'error', summary: 'Hata', detail: response.message });
                        return;
                    }
                    else {

                        if (that.state.infoData.length > 0) {
                            let infoIds = that.state.infoData.map(x => x.properties.id);

                            let newData = response.data.filter(x => !infoIds.includes(parseInt(x.properties.id)));

                            if (newData.length > 0) {
                                that.setState({ infoData: [...that.state.infoData, ...newData] }, () => {
                                    that.setState({ visibleInfoPanel: true })
                                });
                            }
                        }
                        else {
                            that.setState({ infoData: [...that.state.infoData, ...response.data] }, () => {
                                that.setState({ visibleInfoPanel: true })
                            });
                        }
                    }
                });
            }
        }

        setTimeout(() => {
            that.mapTool.removeFeature("info-layer", event.feature);
        }, 100);
    }

    openInfoWindowWithoutInteraction = async (obj, event) => {

        let that = this;

        let wfsLayers = that.mapTool.getMap().getLayers().getArray().filter(x => x.getProperties().name.includes("base-wfs-layer-") && x.getVisible() === true);

        let data = [];

        let wkt = "POINT (" + obj.coordinate[0] + " " + obj.coordinate[1] + ")";

        let template = 'POINT ({x} {y})';

        let finalCoord = olCoordinate.format(proj4(this.mapTool.mapProjection, this.mapTool.wktProjection, obj.coordinate), template, 2);

        let convertedFeature = MapTool.convertToFeature(finalCoord, this.mapTool.wktProjection, this.mapTool.mapProjection);

        if (wfsLayers && wfsLayers.length > 0) {
            for (let i = 0; i < wfsLayers.length; i++) {

                if (that.mapTool.getActiveLayer() && that.mapTool.getActiveLayer().length > 0) {
                    const wfsLayer = wfsLayers[i];

                    const layerId = wfsLayer.get("name").split("base-wfs-layer-")[1];

                    let layer = that.mapTool.getActiveLayer().find(x => x.key === parseInt(layerId));

                    const source = wfsLayer.getSource();

                    if (source) {
                        await source.forEachFeatureIntersectingExtent(convertedFeature, async (feature) => {
                            const properties = feature.getProperties();

                            if (that.state.infoData.length > 0) {

                                let newData = that.state.infoData.filter(x => x.properties.id !== properties.id);

                                if (newData.length === 0) {
                                    const featureIds = feature.getId().toString().split(".");

                                    const id = featureIds.pop();

                                    const name = featureIds[0];

                                    const geoJSON = MapTool.convertFeatureToGeoJson(newFeature, that.props.mapProjection);

                                    let identifierColumn = [];

                                    delete properties.geometry;

                                    if (that.props.checkIdentifierColumn) {
                                        const model = {
                                            layerId: layerId,
                                            properties: JSON.stringify(properties)
                                        }

                                        let response = await infoService.getIdentifierInfo(this.props.mapApiUrl, model).catch(err => {
                                            data = [];
                                        });

                                        if (response && response.success) {
                                            identifierColumn = response.data || [];
                                        }
                                    }

                                    data.push({
                                        id: id,
                                        idColumn: null,
                                        isFormExist: false,
                                        name: name,
                                        properties: properties,
                                        title: layer?.title,
                                        identifierColumns: identifierColumn,
                                        geoJSON: geoJSON
                                    });
                                }
                            }
                            else {
                                let newData = data.filter(x => x.properties.id !== properties.id);

                                if (newData.length === 0) {
                                    const featureIds = feature.getId().toString().split(".");

                                    const id = featureIds.pop();

                                    const name = featureIds[0];

                                    const geoJSON = MapTool.convertFeatureToGeoJson(feature, that.props.mapProjection);

                                    let identifierColumn = [];

                                    delete properties.geometry;

                                    if (that.props.checkIdentifierColumn) {
                                        const model = {
                                            layerId: layerId,
                                            properties: JSON.stringify(properties)
                                        }

                                        let response = await infoService.getIdentifierInfo(this.props.mapApiUrl, model).catch(err => {
                                            identifierColumn = [];
                                        });

                                        if (response && response.success) {
                                            identifierColumn = response.data || [];
                                        }
                                    }

                                    data.push({
                                        id: id,
                                        idColumn: null,
                                        isFormExist: false,
                                        name: name,
                                        properties: properties,
                                        title: layer?.title,
                                        identifierColumns: identifierColumn,
                                        geoJSON: geoJSON
                                    });
                                }
                            }
                        });
                    }
                }
            }
        }

        let wmsLayers = that.mapTool.getMap().getLayers().getArray().filter(x => x.getProperties().name.includes("wms-layer-") && x.getVisible() === true);

        for (let i = 0; i < wmsLayers.length; i++) {

            let source = that.mapTool.getLayerSource(wmsLayers[i].get("name"));

            const coordinates = convertedFeature.getGeometry().getCoordinates();

            if (source.getParams().layers.length > 0) {

                let visibleLevels = source.getParams().visibleLevel;

                let controlLayersZoom = visibleLevels.filter(x => x.minVisibleLevel <= that.mapTool.getZoom() && x.maxVisibleLevel >= that.mapTool.getZoom()).map(x => x.key);

                if (controlLayersZoom.length === 0) {
                    continue;
                }
                else {
                    source.getParams().layers = controlLayersZoom;
                }

                infoService.getFeatureInfo(that.mapTool, coordinates, wmsLayers[i].get("name"), convertedFeature, that.props.checkIdentifierColumn).then((response) => {

                    if (!response.success) {

                        that.toast.current.show({ severity: 'error', summary: 'Hata', detail: response.message });
                        return;
                    }
                    else {

                        if (that.state.infoData.length > 0) {
                            let infoIds = that.state.infoData.map(x => x.properties.id);

                            let newData = response.data.filter(x => !infoIds.includes(parseInt(x.properties.id)));

                            if (newData.length > 0) {
                                that.setState({ infoData: [...that.state.infoData, ...newData], visibleInfoPanel: true });
                            }
                        }
                        else {
                            that.setState({ infoData: [...that.state.infoData, ...response.data], visibleInfoPanel: true });
                        }
                    }
                });
            }
        }

        if (data.length > 0) {
            that.setState({ infoData: [...that.state.infoData, ...data], visibleInfoPanel: true });
        }
    }

    addDefaultInteractions = () => {
        const dragAndDropInteraction = new DragAndDrop({
            formatConstructors: [
                GPX,
                GeoJSON,
                IGC,
                new KML({ extractStyles: true }),
                TopoJSON,
            ],
        });

        dragAndDropInteraction.on('addfeatures', (event) => {
            const workspaceDrawLayer = this.mapTool.getLayerSource("workspace-draw-layer");
            const vectorSource = workspaceDrawLayer;

            vectorSource.addFeatures(event.features);
            this.mapTool.getMap().getView().fit(vectorSource.getExtent());
        });

        this.mapTool.addInteraction(dragAndDropInteraction);

        const infoInteraction = this.mapTool.createDrawInteraction(
            "info-interaction",
            "info-layer",
            "Point"
        );

        infoInteraction.on("drawend", (event) => {
            event.target.setActive(false);

            if (this.props.handleInfo) {
                this.props.handleInfo(event);
            } else {
                this.openInfoWindow(event);
            }
        });

        this.mapTool.addInteraction(infoInteraction);
    };

    addDefaultLayers = () => {

        const infoLayer = MapTool.createVectorLayer({
            name: "info-layer",
            source: MapTool.createVectorLayerSource({})
        });

        this.mapTool.addLayer(infoLayer);

        const workspaceDrawLayer = MapTool.createVectorLayer({
            name: "workspace-draw-layer",
            source: MapTool.createVectorLayerSource({})
        });

        workspaceDrawLayer.setZIndex(999)

        this.mapTool.addLayer(workspaceDrawLayer);

        const workspaceLayer = MapTool.createVectorLayer({
            name: "workspace-layer",
            source: MapTool.createVectorLayerSource({})
        });

        workspaceLayer.setZIndex(999)

        this.mapTool.addLayer(workspaceLayer);

        const workspaceDatabaseLayer = MapTool.createVectorLayer({
            name: "workspace-database-layer",
            source: MapTool.createVectorLayerSource({})
        });

        workspaceDatabaseLayer.setZIndex(999)

        this.mapTool.addLayer(workspaceDatabaseLayer);

        const workspaceGenerateTagLayer = MapTool.createVectorLayer({
            name: "workspace-generate-tag-layer",
            source: MapTool.createVectorLayerSource({})
        });

        this.mapTool.addLayer(workspaceGenerateTagLayer);

        const ncnLayer = MapTool.createVectorLayer({
            name: "ncn-layer",
            source: MapTool.createVectorLayerSource({})
        });

        ncnLayer.setZIndex(999);

        this.mapTool.addLayer(ncnLayer);

        const locationLayer = MapTool.createVectorLayer({
            name: "location-layer",
            source: MapTool.createVectorLayerSource({})
        });

        this.mapTool.addLayer(locationLayer);

        const drawLayer = MapTool.createVectorLayer({
            name: "draw-layer",
            source: MapTool.createVectorLayerSource({})
        });

        this.mapTool.addLayer(drawLayer);
    }
}

export default Map;
